const React = require("react"),
    PropTypes = require('prop-types');
const {Row, Col, Alert, Button, ButtonGroup} = require("react-bootstrap");
const I18n = require("components/widgets/I18n"),
    messages = require("i18n/messages"),
    TextCenter = require("components/widgets/TextCenter"),
    FontAwesome = require("components/widgets/FontAwesome"),
    ModalBasic = require ("components/modals/ModalBasic"),
    ValidInput = require("components/form/ValidInput");
const {TournamentRoundUser} = require("parse/_Domain");
const tournamentUserManagerActions = require("actions/TournamentUserManagerActions");
const tournamentActions = require("actions/TournamentManagerActions");
const {ModalBasicContext}  = require("components/modals/ModalBasicContext");


const TournamentFinalPointModal = ({tRound, tUser, tUserGroup}) =>  {
    let eState = tRound.getFinalConfig().eState;
    let singleMatchResult = tRound.getFinalConfig().groupCounter.length === 1
    let matchResult = tUser.getMatchResults();
    let matchPOS = "-"
    if (matchResult && matchResult[eState] && matchResult[eState]["POS"]) {
        matchPOS = matchResult[eState]["POS"]
    }
    return (
        <ModalBasic
            title={<TextCenter>{tUser.getFullName()}</TextCenter>}
            desc={<TextCenter><strong>{tRound.getName()} - <I18n code={"tournament.final.estate." + eState}/></strong></TextCenter>}
            buttonStyle={"default"}
            buttonChildren={<FontAwesome icon="pencil">{matchPOS}</FontAwesome>}>
            <TournamentFinalPointForm tRound={tRound} tUser={tUser} tUserGroup={tUserGroup} finalConfig={tRound.getFinalConfig()} eState={eState} singleMatchResult={singleMatchResult}/>
        </ModalBasic>
    )
};
TournamentFinalPointModal.propTypes = {
    tUser:PropTypes.object.isRequired,
    tRound: PropTypes.object.isRequired
};
class TournamentFinalPointForm extends React.Component {
    constructor(props) {
        super(props);
        this.refPosition = React.createRef();
        this.refMatchPoints = React.createRef();
        this.clickedSave = this.clickedSave.bind(this);
        this.addGroupPoints = this.addGroupPoints.bind(this);
        this.getDefaultPoints = this.getDefaultPoints.bind(this);
        this.setWinner = this.setWinner.bind(this);
        let finalMatchResults = {};
        let finalRound = this.props.tUser.getFinalTournamentRoundUserID(this.props.tRound);
        if (finalRound != null && finalRound.getMatchResults() != null && finalRound.getMatchResults()[this.props.eState] != null) {
            finalMatchResults = finalRound.getMatchResults()[this.props.eState];
        }
        this.state = {
            groupPoints: finalMatchResults,
            tRoundUser: finalRound
        }
    }
    clickedSave(e) {
        const {closeFct, disableSubmitFct, setErrorFct} = this.context;
        const {tUser, tRound, tUserGroup, eState, singleMatchResult} = this.props;
        const {groupPoints, tRoundUser} = this.state;
        e.preventDefault();
        disableSubmitFct(true);
        // save points
        let matchResults = {}
        let actTRoundUser = tRoundUser;
        if (actTRoundUser == null) {
            // Create new actTRoundUser
            actTRoundUser = new TournamentRoundUser();
            actTRoundUser.setTournamentRoundID(tRound);
            actTRoundUser.setTournamentUserID(tUser);
            actTRoundUser.setTournamentGroupID(tUserGroup);
            // TODO - really null ??
            actTRoundUser.setCountTypeID(null);
        } else {
            // get existing results
            matchResults = actTRoundUser.getMatchResults();
        }

        groupPoints["name"] = tUserGroup.getName()
        if (!singleMatchResult) {
            let sumPoints = 0;
            let matchPoints = 0;
            Object.keys(groupPoints).map(key => {
                if (key.startsWith("S")) {
                    sumPoints += groupPoints[key];
                } else if (key.startsWith("M")) {
                    matchPoints += groupPoints[key];
                }
            })
            groupPoints["matchPoints"] = matchPoints;
            groupPoints["sumPoints"] = sumPoints;
        }
        matchResults[eState] = groupPoints
        actTRoundUser.setMatchResults(matchResults);
        actTRoundUser.setRoundPoints(groupPoints["sumPoints"]);
        actTRoundUser.setKillValue(0)
        actTRoundUser.setKillCounts("f,")
        actTRoundUser.setStatusFinished();
        // save
        tournamentUserManagerActions.saveTournamentUserRound(actTRoundUser, (success) => {
            if (success) {
                tournamentUserManagerActions.reloadTournamentUser(tUser)
                tournamentUserManagerActions.loadTournamentUserGroupsResults(tUser.getTournamentID(), tRound);

                closeFct();
            } else {
                // handle save error
                setErrorFct({message: messages.get("Ergebnis konnte nicht gespeichert werden")});
            }
        });
    }
    setWinner(isWinner) {
        let defMatchPoints = this.props.finalConfig.defMatchPoints;
        let mP = isWinner ? defMatchPoints[0] : defMatchPoints[2];
        let pos = isWinner ? "1" :"2";
        this.refMatchPoints.current.setValue(mP)
        this.addGroupPoints(mP, "M",1)
        this.refPosition.current.setValue(pos)
        this.addGroupPoints(pos, "P", "OS")
    }
    getDefaultPoints(type, groupIndex) {
        if (this.props.singleMatchResult && type === "M") {
            return this.state.groupPoints["matchPoints"]
        } else if (this.props.singleMatchResult && type === "S") {
            return this.state.groupPoints["sumPoints"]
        }
        return this.state.groupPoints[type + groupIndex];
    }
    addGroupPoints(pointsText, type ,groupIndex) {
        let grp = this.state.groupPoints;
        if (this.props.singleMatchResult && type === "M") {
            grp["matchPoints"] = parseInt(pointsText);
        } else if (this.props.singleMatchResult && type === "S") {
            grp["sumPoints"] = parseInt(pointsText);
        } else {
            grp[type + groupIndex] = parseInt(pointsText);
        }
        this.setState({groupPoints:grp})
    }
    render() {
        const {error, submitDisabled} = this.context;
        const validateNow = error && error.length > 0;
        const {tUser, tRound, finalConfig, singleMatchResult} = this.props;
        console.log(tUser.getFullName(), this.props, this.state)
        let lblCode = "Reihung in Gruppe (1,2,3,4..)";
        let lblCode2 = "Match-Siegpunkte eingeben"
        if (tRound.isFinalEliminationFinalPhase()) {
            lblCode = "Reihung im Duell (1,2)"
            lblCode2 = "Duell-Siegpunkte eingeben"
        }
        return (
            <form action="#">
                <Row>
                    <Col xs={12} sm={4}>
                        <ValidInput type="number" ref={this.refPosition}
                                    label={messages.get(lblCode)}
                                    valid={{maxLength: 5, check:['isNumber']}}
                                    onAfterChange={(value) => this.addGroupPoints(value, "P", "OS")}
                                    default={this.getDefaultPoints("P", "OS")}/>
                    </Col>
                    {
                        singleMatchResult ? <Col xs={12} sm={8}>
                            <p style={{marginBottom: "5px"}}>--></p>
                            <ButtonGroup>
                            <Button onClick={() => this.setWinner(true)}><I18n code="tournament.table.column.win"/> ({finalConfig.defMatchPoints[0]} MP)</Button>
                            <Button onClick={() => this.setWinner(false)}><I18n code="tournament.table.column.loose"/> ({finalConfig.defMatchPoints[2]} MP)</Button>
                            </ButtonGroup>
                        </Col> : null
                    }
                </Row>
                <hr/>
                <Row>
                    <Col xs={6}><strong>{lblCode2}</strong></Col>
                    <Col xs={6}><strong>Score eingeben</strong></Col>
                    {

                        finalConfig.groupCounter.map(groupIndex => {
                            return <React.Fragment key={"GRP:" + tRound.id + ":" + groupIndex} >
                                <Col xs={6}>
                                    <ValidInput label={"Match " + groupIndex} type="number" ref={groupIndex === 1 ? this.refMatchPoints : null}
                                                valid={{maxLength: 4, check:['isNumber']}}
                                                onAfterChange={(value) => this.addGroupPoints(value, "M", groupIndex)}
                                                default={this.getDefaultPoints("M", groupIndex)}/>
                                </Col>
                                <Col xs={6}>
                                    <ValidInput label={"Match " + groupIndex} type="number"
                                                valid={{maxLength: 4, check:['isNumber']}}
                                                onAfterChange={(value) => this.addGroupPoints(value, "S",groupIndex)}
                                                default={this.getDefaultPoints("S", groupIndex)}/>
                                </Col>
                            </React.Fragment>
                        })
                    }
                </Row>
                <Row>
                    <Col xs={12}>
                        {error == null ? null : <Alert bsStyle="danger">{error.message}</Alert>}
                        <Button onClick={this.clickedSave} disabled={submitDisabled} block bsStyle="success">
                            <I18n code={"modal.button.save"}/>
                        </Button>
                    </Col>
                </Row>
            </form>
        );
    }
}
TournamentFinalPointForm.propTypes = {
    tUser:PropTypes.object.isRequired,
    tRound: PropTypes.object.isRequired
};
TournamentFinalPointForm.contextType = ModalBasicContext;
module.exports = TournamentFinalPointModal;
